import React, { useState } from 'react';

interface ProfileAvatarProps {
  pictureUrl?: string;
  firstName?: string;
  lastName?: string;
  // Size and border. The picture fills it.
  className?: string;
  // The initials' size, to suit the circle.
  initialsClassName?: string;
}

// The member's picture, or their initials on gold when there is none. Text on a gold fill is
// black (BRAND.md: white on gold is 2.32:1). A picture that fails to load (a migrated record whose
// file never arrived) also falls back to the initials, rather than the browser's broken image.
const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  pictureUrl,
  firstName,
  lastName,
  className = 'h-24 w-24',
  initialsClassName = 'text-2xl',
}) => {
  const initials =
    `${firstName?.trim().charAt(0) ?? ''}${lastName?.trim().charAt(0) ?? ''}`.toUpperCase();
  // Keyed on the URL, so a new picture (or a fresh SAS link) gets its own chance to load.
  const [failedUrl, setFailedUrl] = useState<string>();

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary ${className}`}
    >
      {pictureUrl && pictureUrl !== failedUrl ? (
        <img
          src={pictureUrl}
          alt={`${firstName ?? ''} ${lastName ?? ''}`.trim() || 'Profile'}
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(pictureUrl)}
        />
      ) : (
        <span
          aria-hidden="true"
          className={`font-display font-semibold text-secondary ${initialsClassName}`}
        >
          {initials || '?'}
        </span>
      )}
    </div>
  );
};

export default ProfileAvatar;
